module.exports = __webpack_public_path__ + "static/media/blue-arrow.08ef53d3.svg";